<template>
    <LineChartGenerator
        :chart-options="comp.chartOptions"
        :chart-data="comp.chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="538"
        :height="150"
    />
</template>

<script>
import { reactive, onMounted, watch } from 'vue'
import { Line as LineChartGenerator } from 'vue-chartjs'

import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
)

export default {
    name: 'IntensityChart',
    components: {
        LineChartGenerator
    },
    props: {
        chartId: { type: String, default: 'intensity-chart' },
        datasetIdKey: { type: String, default: 'label' },
        width: { type: String, default: '538' },
        height: { type: String, default: '150' },
        cssClasses: { type: String, default: '' },
        styles: { type: Object, default: () => { return { position:'relative', height:'150px', background:'radial-gradient(#595959, #404040 , #272727)' } } },
        plugins: { type: Array, default: () => [] },
        labels: { type: Object, default:null },
        datalist: { type: Object, default:null },
    },
    setup(props) {
        const comp = reactive({
            width:0, height:0,

            chartData: {
                labels: [ ],
                datasets: [ ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins:{
                    legend: {
                        labels: {
                            boxWidth:8,
                            boxHeight:4,
                            color:'#c8c8c8',
                            font: {
                                size:8,
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        ticks:{
                            autoSkip:false,
                            color:'#c8c8c8',
                            font: {
                                size:11
                            }
                        },
                        grid:{
                            // drawBorder:false,
                            display:false
                        },
                    },
                    y: {
                        display:false
                    }
                }
            },
        })

        watch(() => props.labels, (nVal, oVal) => {
            if( nVal != oVal ){
                comp.chartData.labels = nVal
            }
        })
        watch(() => props.datalist, (nVal, oVal) => {
            if( nVal != oVal ){
                comp.chartData.datasets = []
                for(let i=0; i<nVal.length; i++){
                    let irow = {
                        label: nVal[i].label,
                        data: nVal[i].data,
                        backgroundColor: 'rgba(237,125,49,0.6)',
                        borderColor    : 'rgba(237,125,49,0.6)',
                        borderWidth : 1.5,
                        radius: 1.5,
                        tension: 0.5
                    }
                    if( i == 0 ){
                        irow.backgroundColor = 'rgba(68,114,196,1)'
                        irow.borderColor     = 'rgba(68,114,196,1)'
                    }
                    comp.chartData.datasets.push(irow)
                }
            }
        })

        onMounted(() => {
            // console.log(comp.width, comp.height)
            // console.log(props.modelValue)
        })

        return { comp, props }
    }
}
</script>
